<template functional>
  <div
    v-lazy-load="true"
    class="closet-outfit-container"
    @click="listeners['on-select-option']"
    :tabindex="tabNavigationEnabled ? 0 : null"
    @keyup.enter="listeners['on-select-option']"
  >
    <img
      class="my-closet-preview"
      :src="$options.methods.getOutfitImageUrl(props.previewSrc)"
      draggable="false"
    />
  </div>
</template>

<script>
import UrlHelper from '@/services/UrlHelper';

export default {
  name: 'MyClosetPreview',
  props: ['categoryKey', 'previewSrc', 'tabNavigationEnabled'],
  methods: {
    getOutfitImageUrl: function(url) {
      return UrlHelper.transformOutfitImageBaseURL(url);
    },
  },
};
</script>

<style scoped>
.my-closet-preview {
  height: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.closet-outfit-container {
  height: 150px;
}
</style>
